import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: ${props => props.padding};
  width: 100%;
  transform: translateY(0);
  transition: all 0.5s;
  h1 {
    text-align: left;
    color: white;
    font-weight: 600;
    font-size: 25px;
    line-height: 30px;
    &.light {
      color: #2d1441 !important;
    }
    &.dark {
      color: white !important;
    }
    svg {
      fill: #ffffff;
      display: none;
      margin-right: 10px;
      @media (max-width: 820px) {
        display: inline-block;
      }
    }
    .icon-titulo-historiales {
      fill: #ffffff;
      margin-right: 10px;
      display: none;
      @media (max-width: 820px) {
        display: inline-block;
      }
    }
  }
  h2 {
    margin-top: 3px;
    text-align: left;
    color: #e0dae8;
    font-weight: 300;
    font-size: 16px;
    line-height: 19px;
    span {
      font-weight: 600;
    }
  }
  p {
    color: #7c6c8a;
    font-size: 14px;
    line-height: 17px;
  }
  &.title-doble {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    h1 {
      color: #24152f;
    }
    a {
      color: #24152f;
      font-family: 'cerapro';
      .arrow-back {
        transform: rotate(90deg);
        margin-right: 10px;
      }
    }
  }
`;
const Title = ({ text, size, contrast, icon, children, padding }) => (
  <TitleContainer padding={padding}>
    {size === 'h1' && (
      <h1 className={contrast}>
        {icon && children}
        {text}
      </h1>
    )}
    {size === 'h2' && (
      <h2 className={contrast}>
        {icon && children}
        {text}
      </h2>
    )}
  </TitleContainer>
);

Title.propTypes = {
  text: PropTypes.string.isRequired,
  size: PropTypes.string,
  icon: PropTypes.bool,
  contrast: PropTypes.string,
  children: PropTypes.node,
  padding: PropTypes.string,
};

Title.defaultProps = {
  size: 'h1',
  icon: false,
  contrast: 'dark',
  children: null,
  padding: '20px 0px',
};

export default Title;
